export default __webpack_public_path__ + "static/blog-img3-6411640135c4630bb9a88fb9f1e82a07.png";